//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    events: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    //各种事件
    data: {
      type: Object,
      required: true
    },
    settings: {
      type: Object
    },
    grid: {
      type: Object
    },
    colors: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    remoteFunc: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    remoteFuncName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.reloadData();
  },
  methods: {
    reloadData: function reloadData() {
      var _this = this;

      if (this.remoteFunc.hasOwnProperty(this.remoteFuncName)) {
        this.remoteFunc[this.remoteFuncName](function (columns, data) {
          _this.data.columns = columns;
          _this.data.rows = data;
        });
      }
    }
  }
};